import { api } from './client';

export const getReferralCode = () => api.get('/referrals/code');

export const sendReferralInvite = (email) => api.post('/referrals/invite', { email });

export const getReferralStats = () => api.get('/referrals/stats');
